import dict from "../../Data/dict.json"

function count_day_left(startDate, endDate) {
    const diff = Math.abs(endDate - startDate);
    const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
    const months = Math.floor((diff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
    const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return {
        years,
        months,
        days,
        hours,
        minutes,
        seconds
    };
}

function format_duration({ years = 0, months = 0, days = 0, hours = 0, minutes = 0, seconds = 0 }, lang = "ina") {

    const parts = [];

    if (years > 0) {
        parts.push(`${years} ${dict["years"][lang]}`);
    }

    if (months > 0) {
        parts.push(`${months} ${dict["months"][lang]}`);
    }

    if (days > 0) {
        parts.push(`${days} ${dict["days"][lang]}`);
    }

    if (parts.length === 0 && (hours > 0 || minutes > 0 || seconds > 0)) {
        return dict["Active period less than 1 day"][lang];
    }

    if (parts.length === 0 && !hours && !minutes && !seconds) {
        return dict["Inactive license"][lang];
    }

    return `${dict["Active period"][lang]} ${parts.join(', ')}`;
}

function format_time(totalSeconds, language = "eng") {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = parseInt(totalSeconds % 60);
    let result = "";
    if (language === "eng") {
        if (hours > 0) result += `${hours}h `;
        if (minutes > 0) result += `${minutes}m `;
        if (seconds > 0) result += `${seconds}s`;
    } else {
        if (hours > 0) result += `${hours}j `;
        if (minutes > 0) result += `${minutes}m `;
        if (seconds > 0) result += `${seconds}d`;
    }
    return result
}

export { count_day_left, format_duration, format_time }